import { onlineManager } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

/** Se o aparelho está com rede, pelo `onlineManager` do TanStack (que já escuta `online` e `offline`). */
export function useOnline() {
  return useSyncExternalStore(
    (onChange) => onlineManager.subscribe(onChange),
    () => onlineManager.isOnline(),
    () => true,
  );
}

/** Erro de rede (sem conexão antes de enviar, ou o pedido não teve resposta). */
export function isNetworkError(error: unknown) {
  const code = (error as { code?: unknown } | null)?.code;
  return code === "offline" || code === "network_error";
}
